import React from 'react';

import { IIconProps } from 'assets/icons/IconProps';

export const CreditCardIcon = ({
  width = 24,
  height = 24,
  stroke = '#52575C',
  strokeWidth = 1.5,
}: IIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      d="M18.375 3.5H2.625C1.6585 3.5 0.875 4.2835 0.875 5.25V15.75C0.875 16.7165 1.6585 17.5 2.625 17.5H18.375C19.3415 17.5 20.125 16.7165 20.125 15.75V5.25C20.125 4.2835 19.3415 3.5 18.375 3.5Z"
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M0.875 8.75H20.125"
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
